import { uniqBy } from 'lodash';
import SubmissionStatus from '../Data/SubmissionStatus';
import { setBsaSubmissionStatus } from '../Lib/redux/slices/submission';
import { getShownToCustomer, getSubmissionArgs } from './submission';
import { matchLevels } from '../Lib/redux/sagas/getCustomerMatches/matchLevels';
import { submitStandardLeadWithBsaData } from './submitLead.helpers';

const submitBsaLead = ({
  campaignId,
  components,
  consentedLegalStatementHash,
  consentedSuppliersHash,
  countryCode,
  dispatch,
  formId,
  oneTrustLocale,
  pageUrl,
  parentPageCookies,
  phoneNumberCountryCode,
  referrerUrl,
  sourceSite,
  submitLeadMutation,
  testMode,
  useCidFromURL,
  widgetLabel,
  multipleSupplierConsentedLegalStatementHash,
  singleSupplierConsentedLegalStatementHash,
  consentCertification,
  supplierId,
  visitorId,
  consentStatement,
  privacyPolicyUrl,
  subcategoryName,
  firstSubmissionAttemptTimestamp,
  subcategoryId,
  supplierMatchSelectionEnabled,
  themeName,
  featureFlags,
  oneToOneSupplierConsent,
  shouldFirePhoneStepConversion,
  eventPublicKeyString,
  iFrameId,
  isDomainInternal,
  submissionPageNumber,
  currentPage,
  supplierMatchComponents,
  customerBrandMatches,
  subcategoryBrandMatches,
  matchLevel,
  dynamicSelectAndConnect,
}) => {
  dispatch(
    setBsaSubmissionStatus({
      bsaSubmissionStatus: SubmissionStatus.IN_PROGRESS,
    })
  );

  const componentsWithSupplierMatch = uniqBy(
    [
      ...Object.values(components),
      ...Object.values(supplierMatchComponents ?? {}),
    ],
    (component) => component.component.id
  );

  // The supplier match component carries the customer's selection, so the BSA
  // lead records the same consented, deselected and shown brands as the main
  // lead. It can already sit before the phone page, hence the dedupe.
  // Subcategory fallback brands are not matched to this customer, so the lead
  // keeps the bundled consent and only reports the brands shown.
  // Without a match level no matches request has filled the component yet.
  // Dynamic Select and Connect leads are bundled full-list consent (GOLD-2441),
  // so they keep the phone-page components as the main lead's model expects.
  const isSubcategoryFallback =
    matchLevel === matchLevels.SUBCATEGORY_REVENUE_FALLBACK;
  const isDynamicSelectAndConnect = Boolean(
    dynamicSelectAndConnect?.enableDynamicSelectAndConnect
  );
  const shouldRecordSupplierMatchSelection =
    Boolean(matchLevel) && !isSubcategoryFallback && !isDynamicSelectAndConnect;

  const submissionArgs = getSubmissionArgs({
    campaignId,
    components: shouldRecordSupplierMatchSelection
      ? componentsWithSupplierMatch
      : components,
    consentedLegalStatementHash,
    consentedSuppliersHash,
    countryCode,
    formId,
    phoneNumberCountryCode,
    sourceSite,
    testMode,
    pageUrl,
    referrerUrl,
    widgetLabel,
    useCidFromURL,
    parentPageCookies,
    oneTrustLocale,
    multipleSupplierConsentedLegalStatementHash,
    singleSupplierConsentedLegalStatementHash,
    consentCertification,
    supplierId,
    consentStatement,
    privacyPolicyUrl,
    subcategoryName,
    subcategoryId,
    isBsaOnly: true,
    supplierMatchSelectionEnabled,
    themeName,
    featureFlags,
    oneToOneSupplierConsent,
    customerBrandMatches,
    subcategoryBrandMatches,
    matchLevel,
  });

  if (isSubcategoryFallback && !isDynamicSelectAndConnect) {
    submissionArgs.lead.shownToCustomer = getShownToCustomer({
      components: componentsWithSupplierMatch,
      customerBrandMatches,
      subcategoryBrandMatches,
      supplierMatchSelectionEnabled,
      supplierId,
      matchLevel,
      subcategoryId,
      phoneNumberCountryCode,
    });
  }

  submitStandardLeadWithBsaData({
    submitLeadMutation,
    submissionArgs,
    dispatch,
    visitorId,
    firstSubmissionAttemptTimestamp,
    formId,
    shouldFirePhoneStepConversion,
    components,
    eventPublicKeyString,
    iFrameId,
    isDomainInternal,
    submissionPageNumber,
    currentPage,
  });
};

export default submitBsaLead;
